export default {
    LOAD_NF_GENERATE(state, nf_itens) {
        state.items = nf_itens;
    }
}